import { Col, Row } from 'antd';
import React, { useContext, useEffect, useState } from 'react';

import DashboardNotificationType from 'components/atoms/DashboardNotification';
import Title from 'components/atoms/Title';
import LoadingWrapper from 'components/hoc/LoadingWrapper';
import { Context } from 'components/hoc/Store';
import DashboardCard from 'components/molecules/DashboardCard';

import useNavigateWorkaround from 'hooks/useNavigateWorkaround';
import useProfily from 'hooks/useProfily';

import cisMenyApi from 'services/cisMeny';
import cisStatyApi from 'services/cisStaty';
import nastavitUcetApi from 'services/nastavitUcet';
import profilyApi, { IPristupy } from 'services/profily';

import routePathEnum from 'enums/routePathEnum';

const MainPage: React.FC = () => {
    const { profily, cisStaty, prevPath, token } = useContext(Context);
    const { navigateWorkaround } = useNavigateWorkaround();
    const [loading, setLoading] = useState<boolean>(false);
    const { setLevel } = useProfily();
    const [profiles, setProfiles] = useState<IPristupy[]>([]);

    useEffect(() => {
        if (cisStaty.length < 1) {
            cisStatyApi().then(({ data }) => {
                setLevel('cisStaty', data);
            });
            cisMenyApi().then(({ data }) => {
                setLevel('cisMeny', data);
            });
        }

        setLoading(true);
        if (!prevPath.includes('jinaosoba')) {
            setLevel('aktivniFirma', null);
            setLevel('menuProfile', null);
        } else if (token) {
            setTimeout(
                () =>
                    profilyApi(undefined, true).then(({ data }) => {
                        nastavitUcetApi(data!.sezpristupu![0].iducet).then(() => {
                            setLevel('aktivniFirma', data!.sezpristupu![0]);
                            /* emitentApi().then(resp => {
                                if (Object.keys(resp).length) {
                                    setLevel('menuProfile', {
                                        ...resp,
                                        typemitenta: resp.typemitenta || EEmitentJe.NA
                                    });*/
                            setLevel('dashboardLoading', false);
                            navigateWorkaround(
                                `/firma/${data!.sezpristupu![0].iducet}${routePathEnum.DOKUMENTY_PREHLED}`
                            );
                            setLevel('profily', data);
                            setLevel('ucty', data.sezpristupu!);
                            setLoading(false);
                        });
                        // setLevel('dashboardLoading', false);
                        //   });
                    }),
                0
            );
        }

        /** Clean up akce po prihlaseni */
        return () => setLoading(false);
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [token]);

    useEffect(() => {
        const delayDebounceFn = setTimeout(() => {
            if (!prevPath.includes('jinaosoba')) {
                profilyApi().then(({ data }) => {
                    setLevel('profily', data);
                    setLevel('ucty', data.sezpristupu!);
                    setProfiles(data.sezpristupu!);
                    setLoading(false);
                });
            }
        }, 0);
        return () => clearTimeout(delayDebounceFn);
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    return (
        <LoadingWrapper loading={loading}>
            <DashboardNotificationType profily={profiles} />
            <Row>
                <Col span={24}>
                    <Title
                        level={4}
                        text="ZVOLTE_UCET"
                        style={{
                            color: '#808585',
                            position: 'relative',
                            top: -8
                        }}
                    />
                </Col>
            </Row>
            <DashboardCard profily={profiles || profily} />
        </LoadingWrapper>
    );
};

export default MainPage;
